"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _botframeworkWebchatComponent = require("botframework-webchat-component");

var _CommonCard = _interopRequireDefault(require("./CommonCard"));
/* eslint react/no-array-index-key: "off" */


var VideoContent = _botframeworkWebchatComponent.Components.VideoContent;

var VideoCardAttachment = function VideoCardAttachment(_ref) {
  var adaptiveCardHostConfig = _ref.adaptiveCardHostConfig,
      adaptiveCards = _ref.adaptiveCards,
      attachment = _ref.attachment,
      _ref$attachment = _ref.attachment;
  _ref$attachment = _ref$attachment === void 0 ? {} : _ref$attachment;
  var _ref$attachment$conte = _ref$attachment.content;
  _ref$attachment$conte = _ref$attachment$conte === void 0 ? {} : _ref$attachment$conte;
  var media = _ref$attachment$conte.media,
      autostart = _ref$attachment$conte.autostart,
      autoloop = _ref$attachment$conte.autoloop,
      _ref$attachment$conte2 = _ref$attachment$conte.image;
  _ref$attachment$conte2 = _ref$attachment$conte2 === void 0 ? {} : _ref$attachment$conte2;
  var imageURL = _ref$attachment$conte2.url,
      styleSet = _ref.styleSet;
  return _react.default.createElement("div", {
    className: styleSet.audioCardAttachment
  }, _react.default.createElement("ul", {
    className: "media-list"
  }, media.map(function (_ref2, index) {
    var url = _ref2.url;
    return _react.default.createElement("li", {
      key: index
    }, _react.default.createElement(VideoContent, {
      autoPlay: autostart,
      loop: autoloop,
      poster: imageURL,
      src: url
    }));
  })), _react.default.createElement(_CommonCard.default, {
    adaptiveCardHostConfig: adaptiveCardHostConfig,
    adaptiveCards: adaptiveCards,
    attachment: attachment
  }));
};

VideoCardAttachment.propTypes = {
  adaptiveCardHostConfig: _propTypes.default.any.isRequired,
  adaptiveCards: _propTypes.default.any.isRequired,
  attachment: _propTypes.default.shape({
    content: _propTypes.default.shape({
      autoloop: _propTypes.default.bool,
      autostart: _propTypes.default.bool,
      image: _propTypes.default.shape({
        url: _propTypes.default.string
      }),
      media: _propTypes.default.arrayOf(_propTypes.default.shape({
        url: _propTypes.default.string
      }))
    })
  }).isRequired,
  styleSet: _propTypes.default.shape({
    audioCardAttachment: _propTypes.default.any.isRequired,
    options: _propTypes.default.any.isRequired
  }).isRequired
};

var _default = (0, _botframeworkWebchatComponent.connectToWebChat)(function (_ref3) {
  var styleSet = _ref3.styleSet;
  return {
    styleSet: styleSet
  };
})(VideoCardAttachment);

exports.default = _default;